import { orgCalendarDate, orgWallClock } from '@/lib/utils/custom-date/custom-date';
import { readBankInfo } from '@/modules/service-desk/shared/bank-info';
import { ByodApplication, ByodStatus } from '../types/byod.types';

/** Legacy `BYOD_APPLY_CUTOFF_DAY`: applications after this day of the month are processed next month. */
const BYOD_APPLY_CUTOFF_DAY = 10;

/** Whether today, in the organization's zone, is past the cutoff day of the month. */
export const isPastApplyCutoff = (now: Date = new Date(), timeZone?: string) =>
  orgWallClock(now, timeZone).day > BYOD_APPLY_CUTOFF_DAY;

/**
 * Whether an application was submitted on or before the cutoff day of the month, reading the day of
 * `AppliedDateUtc` in the record's `Timezone` (the organization's zone for old rows without one).
 */
export const isAppliedWithinWindow = (appliedDateUtc?: string, timeZone?: string | null) => {
  const day = orgCalendarDate(appliedDateUtc, timeZone || undefined);
  if (!day) return false;
  return Number(day.slice(8, 10)) <= BYOD_APPLY_CUTOFF_DAY;
};

export const readAccountNumber = (bankInfoJson?: string) =>
  readBankInfo(bankInfoJson).AccountNumber ?? '';

/** Legacy UI: an applicant may edit an application only while it is still pending. */
export const canEditByod = (application: ByodApplication) => application.Status === 'Pending';

/** Pending applications can be approved or rejected; a decided one can only be reverted to pending. */
export const availableByodActions = (status: ByodStatus): ByodStatus[] =>
  status === 'Pending' ? ['Approved', 'Rejected'] : ['Pending'];
